import Component from "../../lib/component";
import { getElementComponentOfType } from "../../lib/global_components";

export const TogglerLinkConfig = {
    componentTypeKey: "TogglerLink",
    baseHtmlClass: "toggler_link",
    selector: ".toggler_link",

    datasetConfigKey: "toggler_link__config",

    targetIdDatasetKey: "toggler_link__target_pane_id",
};

export class TogglerLink extends Component {
    static get config() {
        return TogglerLinkConfig;
    }

    constructor(id_or_element) {
        super({
            element: id_or_element,
            config: TogglerLink.config,
        });

        this.setDatasetConfig(TogglerLink.config.datasetConfigKey);
        this.targetPaneId = this.getDatasetConfigValue(
            TogglerLinkConfig.targetIdDatasetKey,
        );

        this.togglerBtns = getTogglerBtns(this.targetPaneId);

        if (!this.togglerBtns) {
            console.warn(
                "[TogglerLink] No toggler buttons found via the toggler pane ID.",
                this.targetPaneId,
            );
        }

        this.element.addEventListener("click", this.handleClick.bind(this));
    }

    handleClick(event) {
        if (!this.togglerBtns) return;
        const togglerBtn = this.togglerBtns.getTogglerBtnForPaneId(
            this.targetPaneId,
        );
        if (togglerBtn) {
            event.preventDefault();
            event.stopPropagation();
            this.togglerBtns.activateBtn(togglerBtn);
        }
    }
}

function getTogglerBtns(targetPaneElementId) {
    const target_el = document.getElementById(targetPaneElementId);
    if (!target_el) {
        console.error(
            "[TogglerLink] No toggler pane found via the ID.",
            targetPaneElementId,
        );
        return;
    }
    const togglerPane = getElementComponentOfType(target_el, "TogglerPane");
    if (!togglerPane) {
        console.error(
            "[TogglerLink] No toggler pane found via the ID.",
            targetPaneElementId,
        );
        return;
    }
    return togglerPane.togglerBtns;
}
